export default "__VITE_ASSET__Dh53Cvw5__"